import { type ServiceType } from '@/shared/api/order';

const ORDER_TRACKING_INFO: Partial<Record<ServiceType, string>> = {
    YANDEX_DELIVERY: 'Отслеживайте заказ в приложении Яндекс Go',
    CDEK: 'Отслеживайте заказ в приложении CDEK',
    META_SHIP_RUSSIAN_POST: 'Отслеживайте заказ в приложении Почта\u00a0России',
    META_SHIP_DALLI: 'Отслеживайте заказ на сайте Dalli',
    META_SHIP_PECOM: 'Отслеживайте заказ в приложении ПЭК',
    MERCHANT_SHIP: 'Отслеживайте статус заказа по email',
    OZON: 'Отслеживайте заказ в приложении Ozon',
    YANDEX_MARKET_FBO: '',
    HOLODILNIK: '',
    SELF: '',
};

export const getOrderTrackingInfo = (serviceType: ServiceType) => ORDER_TRACKING_INFO[serviceType];
